import type { Components, Theme } from '@mui/material/styles';
export function inputOverrides(theme: Theme): Components<Theme> {
  const mobile = theme.breakpoints.down('sm');

  const ease = theme.transitions.easing.easeOut;
  const containedShadow =
    theme.palette.mode === 'dark' ? '0 1px 2px rgba(0,0,0,0.5)' : '0 1px 2px rgba(16,24,40,0.05)';
  const containedShadowHover =
    theme.palette.mode === 'dark' ? '0 2px 4px rgba(0,0,0,0.6)' : '0 2px 4px rgba(16,24,40,0.08)';

  return {
    MuiButtonBase: {
      defaultProps: { disableRipple: false },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          minHeight: 36,
          padding: '6px 16px',
          transition: `background-color 150ms ${ease}, box-shadow 150ms ${ease}, transform 150ms ${ease}`,
          '&:active': { transform: 'scale(0.98)' },
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:active': { transform: 'none' },
          },
          [mobile]: { minHeight: 44 },
        },
        sizeSmall: {
          minHeight: 32,
          padding: '4px 12px',
          fontSize: '0.8125rem',
          [mobile]: { minHeight: 44 },
        },
        sizeLarge: { minHeight: 44, padding: '8px 16px' },
        contained: {
          boxShadow: containedShadow,
          '&:hover': { boxShadow: containedShadowHover },
          '&:active': { boxShadow: 'none', transform: 'scale(0.98)' },
        },
        containedPrimary: {
          '&:hover': { backgroundColor: theme.palette.primary.dark },
        },
        outlined: { borderColor: theme.palette.divider },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          [mobile]: { minWidth: 44, minHeight: 44 },
        },
        sizeSmall: {
          [mobile]: { minWidth: 44, minHeight: 44 },
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small', fullWidth: true },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          backgroundColor: theme.palette.background.paper,
          '&.Mui-focused': { boxShadow: theme.customShadows.focus },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1 },
          [mobile]: { minHeight: 44, fontSize: '1rem' },
        },
        input: {
          [mobile]: { fontSize: '1rem', paddingTop: 12, paddingBottom: 12 },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: { size: 'small' },
      styleOverrides: {
        root: {
          [mobile]: { fontSize: '0.875rem' },
        },
      },
    },
    MuiSelect: {
      defaultProps: { native: false },
    },
    MuiFormControl: {
      styleOverrides: {
        root: { [mobile]: { width: '100%' } },
      },
    },
  };
}
